import { ArtworkAssets } from "@sourceful/shared-types";

export const hasDielineArtwork = (artwork: ArtworkAssets | undefined) => {
  if (!artwork) return false;
  return Object.values(artwork).some(val => !!val);
};
